export enum ArtistDiscographyTableColumn {
	TITLE = 'title',
	UPC = 'upc',
	RELEASE_DATE = 'releaseDate',
	CHECKBOX = 'checkbox',
	STATUS = 'status',
	LABEL_NAME = 'labelName',
	PROVIDER_NAME = 'providerName',
}
